export enum LotStatusEnum {
    Pending = 'Pending',
    Finalized = 'Finalized',
}
